function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.83333 19.7778C6.57407 18.6667 8.94444 16.4444 12.5 16.4444C16.0556 16.4444 18.4259 18.6667 19.1667 19.7778M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12ZM15.8333 9.77778C15.8333 11.6187 14.3409 13.1111 12.5 13.1111C10.6591 13.1111 9.16667 11.6187 9.16667 9.77778C9.16667 7.93683 10.6591 6.44444 12.5 6.44444C14.3409 6.44444 15.8333 7.93683 15.8333 9.77778Z",
  stroke: "currentColor",
  strokeWidth: 2
});
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.fd7bb312.svg";
export { ForwardRef as ReactComponent };